import { render, staticRenderFns } from "./class.vue?vue&type=template&id=20a1f2da&scoped=true"
import script from "./class.vue?vue&type=script&lang=js"
export * from "./class.vue?vue&type=script&lang=js"
import style0 from "./class.vue?vue&type=style&index=0&id=20a1f2da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a1f2da",
  null
  
)

export default component.exports